import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SpouseComponent } from './spouse.component';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { InputModule } from '../../../shared/component/common/input/input.module';
import { CheckboxModule } from '../../../shared/component/common/checkbox/checkbox.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    InputModule,
    ReactiveFormsModule,
    CheckboxModule,
  ],
  declarations: [SpouseComponent]
})
export class SpouseComponentModule {}
